import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { RcIconButton } from '../../../Buttons/IconButton';
export var PickerBaseIconButton = forwardRef(function (props, ref) {
    var children = props.children, selected = props.selected, hidden = props.hidden, rest = __rest(props, ["children", "selected", "hidden"]);
    return (React.createElement(RcIconButton, __assign({ elevation: 0, activeElevation: 0, ref: ref, variant: selected ? 'contained' : 'round', color: selected ? 'interactive.b02' : 'neutral.f06', "data-hidden": hidden, size: "xsmall", focusVariant: "focusRing" }, rest), children));
});
PickerBaseIconButton.displayName = 'PickerBaseIconButton';
